const awsmobile = {
    Auth: {
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USERPOOLID,
        userPoolWebClientId: process.env.REACT_APP_CLIENTID,
    }
}

export default awsmobile;